import config from '../../lib/config'
const { routes, RE } = config
const  EventBus = window.VueEventBus
import {html$, style$} from '../../lib/utils'

import { createNamespacedHelpers } from 'vuex'
import { namespace } from '../../vuexstore'
import { default as store, namespace as pageNamespace } from '../../vuexstore/modules/pages'
import { namespace as authNamespace } from '../../vuexstore/modules/auth'

import { mapGetters as rootMapGetters, mapActions as rootMapActions } from 'vuex'

const { mapGetters, mapActions } = createNamespacedHelpers([namespace, pageNamespace].join('/'))
const { mapGetters: mapAuthGetters, mapActions: mapAuthActions } = createNamespacedHelpers([namespace, authNamespace].join('/'))

import ProductsMixins from './products'
import AlertMixins from './alert'

const mixins = [AlertMixins, ProductsMixins]

export default {
  mixins,
  created() {

  },
  mounted() {

  },
  computed: {
    ...mapGetters(Object.keys(store.getters)),
    ...mapAuthGetters(['customer', 'isFbUser']),
    ...rootMapGetters(['authUser', 'authToken', 'authCheck', 'shadowToken']),
    needsLogin() {
      return !this.authCheck
    }

  },
  methods: {
    preventNonNumber(event) {
      event = event || window.event
      const charCode = event.which || event.keyCode
      if ((charCode >= 48 && charCode <= 57) || (charCode >= 9 && charCode <= 13)) {
        return true
      }
      event.preventDefault()
    },
    setBg(url) {
      url = url || this.backgroundImage
      const uri = url ?  `url('${url}')` : 'none'
      const wall = config.BACKGROUND_WALL || '.supercharged-entertainment-container'
      style$({backgroundImage: uri, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center'}, wall)
    },
    gotoLogin() {
      this.goto('page-login')
    },
    gotoLoginFromCart() {
      this.setPostLoginPage('page-checkout')
      this.setPostLoginSection('billing')
      this.gotoLogin()
    },
    gotoRegistrationFromCart() {
      this.setPostLoginPage('page-checkout')
      this.setPostLoginSection('billing')
      this.gotoRegistration()
    },
    gotoRegistration() {
      this.goto('page-registration')
    },
    getRouteUrl(page) {
      const map = {
        'race': 'racewaybooking.race',
        'a race': 'racewaybooking.race',
        'pro': 'racewaybooking.race',
        'pro-race': 'racewaybooking.race',
        'racebooking': 'racewaybooking.race',
        'race booking': 'racewaybooking.race',
        'race-booking': 'racewaybooking.race',
        'racebookings': 'racewaybooking.race',
        'race bookings': 'racewaybooking.race',
        'race-bookings': 'racewaybooking.race',
        'race-pro': 'racewaybooking.race',
        'race-super': 'racewaybooking.race',

        'axe': 'supercharged.axe-throwing',
        'axe-throwing': 'supercharged.axe-throwing',

        'ninja': 'racewaybooking.ninja',
        'race-ninja': 'racewaybooking.ninja',
        'ninjawipeout': 'racewaybooking.ninja',
        'ninja-wipeout': 'racewaybooking.ninja',
        'ninja wipeout': 'racewaybooking.ninja',

        'gift-card': 'racewaybooking.gift-card',
        'giftcard': 'racewaybooking.gift-card',
        'login': 'sign-in',
        'registration': 'user.register',
        'forget-password': 'user.password.reset',
        'profile': 'user.profile',
        'cart': 'racewaybooking.checkout',
        'checkout': 'racewaybooking.checkout',
      }
      page = page.toLowerCase().replace(/^page-/, '')
      let url = page
      page = map[page] || url
      if (page) {
        const resolve = this.$router.resolve({name: page})
        if (resolve) {
          const route = resolve.route || {}
          const matched = route.matched
          if (matched.length) {
            url = route.path || url
          }
        }
      }
      return url
    },
    goto(page) {
      const url = this.getRouteUrl(page)

      if (url) {
        this.$router.push(url)
      }
    },
    ...mapActions(Object.keys(store.actions)),
    ...mapAuthActions(['setCustomer', 'register']),
    ...rootMapActions(['saveToken', 'fetchUser', 'updateUser', 'saveShadowToken', 'authGuard', 'logout'])

  }
}
